// extracted by mini-css-extract-plugin
export var $animation_name = "Cta-module--$animation_name--3bd50";
export var Cta = "Cta-module--Cta--ed5e0";
export var Cta__title = "Cta-module--Cta__title--e1d02";